export default __webpack_public_path__ + "static/media/kokoskladdkaka.2378c258.jpg";